// Колокольчик шапки (В1) — состояние из наличия/здоровья продукта «Уведомления»;
// ленту/ящик здесь не строим, это начинка продукта.
export function notifyStateFor(products) {
    const notifyProduct = products.find((p) => p.product === "notifications" && !p.role) ?? null;
    return { installed: !!notifyProduct, healthy: notifyProduct?.status === "ok" };
}
// buildKitPoll — ANN-V2 Ш6: kind=yesno даёт две опции id 'yes'/'no' (подписи из params.yesno,
// иначе фолбэк вызывающего); kind=poll — варианты Draft.Poll как есть; kind=rating — варианты
// 1..scale одним рядом (item.poll.scale у кита), низ/верх шкалы — Rating.Low/High.
function buildKitPoll(n, yesNoFallback) {
    if (n.kind === "yesno") {
        return { options: [{ id: "yes", label: n.yesno?.yes || yesNoFallback.yes }, { id: "no", label: n.yesno?.no || yesNoFallback.no }], multi: false };
    }
    if (n.kind === "poll" && n.poll) {
        return { options: n.poll.options, multi: n.poll.multi };
    }
    if (n.kind === "rating" && n.rating) {
        const scale = n.rating.scale > 0 ? n.rating.scale : 5;
        const options = Array.from({ length: scale }, (_, i) => ({ id: String(i + 1), label: String(i + 1) }));
        return { options, multi: false, scale: true, low: n.rating.low, high: n.rating.high };
    }
    return undefined;
}
// toKitItem — единственный путь превращения NotificationItem в строку кита (NOTIF-QF3): ящик и
// тосты собственности продукта-источника читают отсюда, а не каждый своим обращением к
// productDict, иначе тост/строка могут разойтись, если словарь догрузился между их кадрами.
// yesNoFallback — подписи кнопок «Да»/«Нет», когда params.yesno их не несёт (словарь Оболочки,
// не хардкод здесь — вызывающий useNotify.ts передаёт t()); по умолчанию пусто для тестов без React.
export function toKitItem(n, dict, yesNoFallback = { yes: "", no: "" }) {
    const { text, known } = dict.notifyText(n.sourceSlug, n.key, n.params);
    return {
        id: n.id,
        source: dict.productTitle(n.sourceSlug),
        text,
        ts: n.createdAt,
        target: known ? n.deepLink : undefined,
        annId: n.annId,
        title: n.title,
        tag: n.tag?.label,
        tagColor: n.tag?.color,
        required: n.required,
        confirmLabel: n.confirmLabel,
        poll: buildKitPoll(n, yesNoFallback),
    };
}
// openDeepLink — переход внутри SPA (pushState + синтетический popstate): тот же приём, что
// navigate() в useProductMenu.ts (слушатель popstate там уже стоит), но без доступа к его
// состоянию — Frame колокольчика навигатор продуктов пропом не получает (App.tsx вне
// write-списка задачи NOTIF-2B, а сам хук useProductMenu — не общий модуль).
// Только внутренний путь: ровно один ведущий "/" (не "//" — это переход на другой хост), иначе
// deep_link чужого продукта молча игнорируется, не уводит вкладку наружу.
export function openDeepLink(href) {
    if (!/^\/(?!\/)/.test(href))
        return;
    window.history.pushState(null, "", href);
    window.dispatchEvent(new PopStateEvent("popstate"));
}
// openNotifyItemEffect — клик по строке ящика/тоста (NOTIF-QF3): строку разбираем всегда;
// пустой deep_link (текст без ссылки, ключ notifications.ann.new) — только разбор, ящик остаётся
// открытым и навигации нет; непустой — ящик закрывается и идёт переход (как раньше).
export function openNotifyItemEffect(target, actions) {
    actions.clear();
    if (target) {
        actions.closeDrawer();
        actions.navigate(target);
    }
}
// parseRuDate — «История» кита отдаёт диапазон в русской форме (kit/v5/src/molecules/date-picker.jsx
// formatRuDate: dd.mm.yyyy); Frame.tsx переводит её в ISO для двери /api/notifications/history.
// Нераспознанная форма — undefined, вызывающий обязан отказаться от запроса (F3), не отбрасывать фильтр молча.
export function parseRuDate(s) {
    const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(s);
    if (!m)
        return undefined;
    return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
}
// endOfDayRuDate — граница «по» включает весь день целиком (23:59:59.999), не только полночь его начала.
export function endOfDayRuDate(s) {
    const d = parseRuDate(s);
    if (!d)
        return undefined;
    d.setHours(23, 59, 59, 999);
    return d;
}
